import { WorkExperience, Education } from '../types';

interface ResumeProps {
  experience: WorkExperience[];
  education: Education[];
}

function Resume({ experience, education }: ResumeProps) {
  return (
    <div id="fh5co-resume" className="fh5co-bg-color">
      <div className="container">
        <div className="row animate-box">
          <div className="col-md-8 col-md-offset-2 text-center fh5co-heading">
            <h2>My Resume</h2>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 col-md-offset-0">
            <ul className="timeline">
              <li className="timeline-heading text-center animate-box">
                <div><h3>Work Experience</h3></div>
              </li>
              {experience.map((job, index) => {
                const className = index % 2 === 0 ? 'timeline-inverted' : 'timeline-unverted';
                return (
                  <li key={index} className={`${className} animate-box`}>
                    <div className="timeline-badge"><i className="icon-suitcase"></i></div>
                    <div className="timeline-panel">
                      <div className="timeline-heading">
                        <h3 className="timeline-title">{job.title}</h3>
                        <span className="company">{job.company} - {job.period}</span>
                      </div>
                      <div className="timeline-body">
                        <p>{job.description}</p>
                      </div>
                    </div>
                  </li>
                );
              })}

              <br />
              <li className="timeline-heading text-center animate-box">
                <div><h3>Education</h3></div>
              </li>

              {education.map((edu, index) => {
                const className = index % 2 === 0 ? 'timeline-unverted' : 'timeline-inverted';
                return (
                  <li key={index} className={`${className} animate-box`}>
                    <div className="timeline-badge"><i className="icon-graduation-cap"></i></div>
                    <div className="timeline-panel">
                      <div className="timeline-heading">
                        <h3 className="timeline-title">{edu.title}</h3>
                        <span className="company">{edu.institution} - {edu.period}</span>
                      </div>
                      <div className="timeline-body">
                        <p>{edu.description}</p>
                      </div>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Resume;
